/* Progressive styling of the existing GoodApps gate; the app owns validation/storage. */
(()=>{
 if(!document.body.classList.contains('phntm-v2'))return;
 function enhanceAge(){
  const root=document.querySelector('#goodav-root'),panel=root?.querySelector('.goodav-cart__body');
  if(!panel||panel.dataset.phntmAgeReady)return;
  panel.dataset.phntmAgeReady='true';
  const title=panel.querySelector('.goodav-cart__timer-title');
  if(title){title.textContent='GOOD TIMES. GROWN-UPS ONLY.';title.id='P2AgeTitle';panel.setAttribute('aria-labelledby',title.id)}
  panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');
  const css=document.querySelector('link[href*="phntm-popups.css"]'),logo=panel.querySelector('.goodav-cart__timer-img');
  if(css&&logo){logo.src=new URL('phntm-octopus-supplied.png',css.href).href;logo.alt='PHNTM';logo.removeAttribute('srcset')}
  const note=document.createElement('p');note.className='p2-age-note';note.textContent='A little age check. Then your kind of good time.';panel.querySelector('.goodav-cart__timer-wrap')?.append(note);
 }
 function enhanceEmail(){
  for(const widget of document.querySelectorAll('.slf-widget')){
   const artwork=widget.querySelector('img[src*="djpcXypKHtBvjXjjgUTdIxv06zgjh1ToCePvChpt.png"]');
   if(!artwork)continue;
   widget.classList.add('p2-email-offer');
   const block=document.createElement('div');block.className='p2-email-art';
   const css=document.querySelector('link[href*="phntm-popups.css"]');
   if(css){const logo=document.createElement('img');logo.src=new URL('phntm-octopus-supplied.png',css.href).href;logo.alt='PHNTM';logo.width=94;logo.height=94;block.append(logo)}
   const title=document.createElement('h2');title.append('BUY ONE.',document.createElement('br'));const highlight=document.createElement('span');highlight.textContent='GET ONE FREE.';title.append(highlight);
   const note=document.createElement('p');note.textContent='On your first order.';block.append(title,note);artwork.replaceWith(block);
   widget.querySelector('input[type="email"]')?.setAttribute('aria-label','Email address');
  }
 }
 function enhance(){enhanceAge();enhanceEmail()}
 enhance();const observer=new MutationObserver(enhance);observer.observe(document.body,{childList:true,subtree:true});
})();
